import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ITariffList } from "../../../Pages/Tariff/ITariff";

export const TariffSlicer = createSlice({
  name: 'Tariff',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ITariffList[]>,
  reducers: {
    getTariff: (state) => {
      state.isLoading = true;
    },
    successGetTariff: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetTariff: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

export const { getTariff, failureGetTariff, successGetTariff } =
  TariffSlicer.actions;

export default TariffSlicer.reducer;
